(function(runtime) {
    var components = runtime.components;
    var _ = components.dependencies._;
    var Modernizr = components.dependencies.Modernizr;
    var $ = components.dependencies.jQuery.v1_11;

    var constants = {
        selectors: {
            openOnContainerBehaviorPattern: '[data-ixp-behavior-{0}-share-on-container]',
            canonicalUrl: '[rel="canonical"]',
            ogUrl: '[property="og:url"]',
            ogImage: '[property="og:image"]',
            shareContainer: '.ixp-c-social-share'
        },
        links: {
            facebook: 'https://www.facebook.com/sharer/sharer.php?u={0}&t={1}',
            twitter: 'https://twitter.com/intent/tweet?url={0}&text={1}',
            google: 'https://plus.google.com/share?url={0}',
            linkedin: 'http://www.linkedin.com/shareArticle?mini=true&url={0}&title={1}&summary={2}&source={3}',
            pinterest: 'http://pinterest.com/pin/create/button/?url={0}&media={1}&description={2}',
            email: 'mailto:?subject={0}&body={1}',
            whatsapp: 'https://web.whatsapp.com/send?text={0}',
            whatsappMobile: 'https://api.whatsapp.com/send?text={0}'
        },
        window: {
            name: 'IxpSocialShareV2',
            size: 'width=640,height=500'
        },
        behaviors: {
            openEnding: '-share',
            openOnContainerEnding: '-share-on-container'
        },
        data: {
            componentRoot: 'data-ixp-component-root',
            openBehaviorPattern: 'data-ixp-behavior-{0}-share',
            openBehaviorScopePattern: 'data-ixp-behavior-scope-{0}-share',
            openOnContainerBehaviorPattern: 'data-ixp-behavior-{0}-share-on-container'
        },
        keyboardKeys: {
            enter: 13,
            space: 32
        }
    };

    runtime.components.register('ixp-social-share-v2', {
        initialize: function(options) {
        },
        onDocumentReady: function() {
        },
        onGetCssClassesToPreserve: function() {
        },
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            var container = builder.scaffoldContainer('Social Share');
            var facebook = builder.scaffold('ixp-facebook-share', 'Facebook Share');
            var twitter = builder.scaffold('ixp-twitter-share', 'Twitter Share');

            var socialComponents = [ facebook, twitter ];

            container.content.scaffolding = socialComponents;

            return {
                scaffolding: [ container ],
                style: {
                    customClass: builder.getDefaultThemes({
                        'socialorientation': '',
                        'socialstyle': '',
                        'socialicon': '',
                        'socialcontainer': ''

                    })
                }
            };
        },
        onStudioStateChanged: function() {
        },
        onListenToStudioEvents: function(events) {
        },
        _setOrientation: function() {},
        disallowedChildrenTypes: function() {
            return [ 'ixp-social-share-v2' ];
        },
        allowedChildrenTypes: function () {
            return [
                'ixp-facebook-share',
                'ixp-twitter-share',
                'ixp-googleplus-share',
                'ixp-linkedin-share',
                'ixp-pinterest-share',
                'ixp-email-share',
                'ixp-whatsapp-share'
            ];
        }
    });

    var formatWith = function (str) {
        var args = Array.prototype.slice.call(arguments, 1);
        return str.replace(/{(\d+)}/g, function (match, number) {
            var val = args[number];
            return val !== undefined ? val : '';
        });
    };

    var urlEncode = function(str) {
        return encodeURIComponent(str);
    };

    var getMetaContent = function(selector, attr) {
        attr || (attr = 'content');
        var $meta = $(selector);
        if (!$meta.length) {
            return;
        }
        return $meta.first().attr(attr) || '';
    };

    var docUrl = window.location.href;
    var canonicalUrl;
    var getCanonicalUrl = function() {
        if (canonicalUrl === undefined) {
            canonicalUrl = getMetaContent(constants.selectors.canonicalUrl, 'href');
        }
        return canonicalUrl;
    };
    var ogUrl;
    var getOgUrl = function(){
        if (ogUrl === undefined) {
            ogUrl = getMetaContent(constants.selectors.ogUrl);
        }
        return ogUrl;
    };
    var ogImage;
    var getOgImage = function(){
        if (ogImage === undefined) {
            ogImage = getMetaContent(constants.selectors.ogImage);
        }
        return ogImage;
    };

    var getMetaData = function() {
        return {
            docUrl: docUrl,
            canonicalUrl: getCanonicalUrl(),
            ogUrl: getOgUrl(),
            ogImage: getOgImage()
        }
    };

    var SocialLink = function(component, options) {
        this.url = component.shareLink;
        this.convert = component.share_convert;
        this.tag = component.share_tag;
        this.sizing = options.sizing || constants.window.size;
        this.type = options.type;
        this.component = component;

        var $el = component.$el;

        var openBehavior = options.type + constants.behaviors.openEnding;
        component.onBehavior($el, openBehavior, _.bind(this.open, this));

        var openBehaviorOnContainer = formatWith(constants.selectors.openOnContainerBehaviorPattern, options.type);
        if ($el.is(openBehaviorOnContainer)) {
            $el.on('click', _.bind(this.open, this));
            $el.on('keyup', _.bind(this.onKeyUp, this));
        }
    };

    SocialLink.prototype.onKeyUp = function(event) {
        if(event.keyCode == constants.keyboardKeys.enter || event.keyCode == constants.keyboardKeys.space){
            this.open();
        }
    };

    SocialLink.prototype.open = function() {
        if (this.convert) {
            runtime.convert();
        }

        if (this.tag) {
            runtime.tag(this.tag);
        }

        // Delegate event to parent (ixp-social-share) container
        var containerId = this.component.$el
            .closest(constants.selectors.shareContainer)
            .data(constants.data.componentRoot.replace('data-', ''));

        if (containerId && runtime.components.getInstance(containerId)) {
            runtime.components.getInstance(containerId).instance.pushInteraction({
                name: 'social sharing',
                type: this.type,
                url: this.url
            })
        }

        if (this.url.indexOf('mailto:') > -1) {
            window.location.href = this.url;
        } else {
            window.open(this.url, constants.window.name, this.sizing);
        }
    };

    var getSocialScaffolding = function(containerName, type, scaffoldingKey, builder, options) {
            var container = builder.scaffoldContainer(containerName);

            var behaviorAttr = formatWith(constants.data.openOnContainerBehaviorPattern, type);
            var behaviorScopeAttr = formatWith(constants.data.openBehaviorScopePattern, type);
            var token = new Date().getTime() + '_' + type + '-share';

            var attrs = {};
            attrs[behaviorAttr] = '';
            attrs[behaviorScopeAttr] = token;

            return {
                scaffolding: [ container ],
                content: {
                    htmlAttributes: attrs
                }
            };
    };

    runtime.components.register('ixp-facebook-share', {
        initialize: function(options) {
            if (this.inStudio) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'facebook',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var meta = getMetaData();
            var url = urlEncode(this.share_url || meta.ogUrl || meta.canonicalUrl || meta.docUrl);
            var title = urlEncode(this.share_title || '');
            this.shareLink = formatWith(constants.links.facebook, url, title);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('Facebook Container', 'facebook', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });

    runtime.components.register('ixp-twitter-share', {
        initialize: function(options) {
            if (this.inStudio) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'twitter',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var meta = getMetaData();
            var url = urlEncode(meta.ogUrl || meta.canonicalUrl || meta.docUrl);
            var tweet = urlEncode(this.tweet_message || '');
            this.shareLink = formatWith(constants.links.twitter, url, tweet);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('Twitter Container', 'twitter', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });

    runtime.components.register('ixp-googleplus-share', {
        initialize: function(options) {
            if (this.inStudio) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'googleplus',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var meta = getMetaData();
            var url = urlEncode(this.share_url || meta.ogUrl || meta.canonicalUrl || meta.docUrl);
            this.shareLink = formatWith(constants.links.google, url);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('Google+ Container', 'googleplus', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });

    runtime.components.register('ixp-linkedin-share', {
        initialize: function(options) {
            if (this.inStudio) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'linkedin',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var meta = getMetaData();
            var url = urlEncode(this.share_url || meta.ogUrl || meta.canonicalUrl || meta.docUrl);
            var title = urlEncode(this.share_title || '');
            var description = urlEncode(this.share_description || '');
            this.shareLink = formatWith(constants.links.linkedin, url, title, description);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('Linkedin Container', 'linkedin', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });

    runtime.components.register('ixp-pinterest-share', {
        initialize: function(options) {
            if (this.inStudio) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'pinterest',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var meta = getMetaData();
            var url = urlEncode(this.share_url || meta.ogUrl || meta.canonicalUrl || meta.docUrl);
            var title = urlEncode(this.share_title || '');
            var image = urlEncode(this.share_image || '');
            this.shareLink = formatWith(constants.links.pinterest, url, image, title);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('Pinterest Container', 'pinterest', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });

    runtime.components.register('ixp-email-share', {
        initialize: function(options) {
            if (this.inStudio || !this.share_subject || !this.share_message) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'email',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var subject = urlEncode(this.share_subject || '');
            var message = urlEncode(this.share_message || '');
            this.shareLink = formatWith(constants.links.email, subject, message);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('Email Container', 'email', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });

    runtime.components.register('ixp-whatsapp-share', {
        initialize: function() {
            if (this.inStudio) {
                return;
            }

            this._setShareLink();

            this.socialLink = new SocialLink(this, {
                type: 'whatsapp',
                sizing: ''
            });
        },
        _setShareLink: function() {
            var meta = getMetaData();
            var url = meta.ogUrl || meta.canonicalUrl || meta.docUrl;
            var message = this.share_message || '';
            var fullMessage = urlEncode(message ? message + ' ' + url : url);
            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            var link = isMobile ? constants.links.whatsappMobile : constants.links.whatsapp;

            this.shareLink = formatWith(link, fullMessage);
        },
        // studio
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return getSocialScaffolding('WhatsApp Container', 'whatsapp', scaffoldingKey, builder, options);
        },
        allowedDropTargets: function () {
            return [ 'ixp-social-share-v2' ];
        }
    });
})(window.ixp.runtime);
